import * as React from "react";
const SvgArrowDropDown = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m7 10 5 5 5-5H7Z",
  fill: "currentColor"
}));
export default SvgArrowDropDown;